module.exports = __webpack_public_path__ + "media/images/card-1a66e9552579d3400375e39caaee4acc.svg";